<template>
  <div>
    <v-app>
      <router-view />
    </v-app>
    <Loader :dialog-loader="loadingGlobal" message="Cargando..."></Loader>
  </div>
</template>

<script>
import Loader from "@/components/common/Loader";
export default {
  name: "App",
  components: {
    Loader
  },
  mounted() {
    if (!this.settings) {
      this.getSettings();
    }
  }
};
</script>

<style lang="scss"></style>
